import { useIntl } from 'react-intl';

import { GenericErrorDisplay } from '@/common/displays';

import { useCriticalErrorDisplayAnalytics } from './hooks';
import { messages } from './messages';

export const CriticalErrorDisplay = () => {
	const intl = useIntl();
	const { refreshPortalButtonClickUIEvent } = useCriticalErrorDisplayAnalytics();

	const onRefresh = () => {
		refreshPortalButtonClickUIEvent();
		window.location.reload();
	};

	return (
		<GenericErrorDisplay
			customMessage={intl.formatMessage(messages.criticalErrorCustomText)}
			onRefresh={onRefresh}
		/>
	);
};
